const defaultApiUrl = "https://mitserver.app:8260";

const getApiUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

const getSocketUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

module.exports = {
	apiUrl: defaultApiUrl,
	getApiUrl,
	getSocketUrl,
};
